import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Table as DoodTable, TableContainer } from 'dood-react-components';

import { clientActions } from '../../actions';
import { translator } from '../../helpers';

class Table extends Component {
    constructor(props) {
        super(props);

        this.state = {
            clients: null,
            loading: false
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = options => {
        this.props.dispatch(clientActions.table(options)).then(
            result => {
                this.setState({
                    clients: result,
                    pagination: result.pagination,
                    filters: result.filters,
                    loading: false
                });
            },
            error => {
                this.setState({ error });
            }
        );
    };

    handleTableChange = (pagination, filters, sorter) => {
        this.setState({ loading: true });

        this.loadData({
            ...this.state.clients.options,
            pagination: { ...pagination, current: pagination.current },
            sortField: sorter.columnKey,
            sortOrder: sorter.order,
            filters: filters
        });
    };

    render() {
        const { clients, loading } = this.state;

        let tableComponent = null;

        if (clients) {
            const { data, columns, filters, pagination } = clients;

            tableComponent = (
                <DoodTable
                    translate={this.props.translate}
                    loading={loading}
                    data={data}
                    columns={columns}
                    filters={filters}
                    pagination={pagination}
                    onActionClick={this.handleActionClick}
                    onTableChange={this.handleTableChange}
                />
            );
        }

        return (
            <TableContainer
                translate={this.props.translate}
                title="Clienti"
                tableComponent={tableComponent}
                error={this.state.error}
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        translate: translator(state)
    };
};

export default connect(mapStateToProps)(Table);
